import React, {useEffect, useState} from "react";
import ReactDOM from "react-dom";
import $ from "jquery";
import {useDateRangePicker} from "./CustomHooks";
import DataService from "./DataService";
import PhotoModal from "./PhotoModal";
import toastr from "toastr";
import {
    Alert,
    Box,
    Button,
    Card,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Grid,
    IconButton,
    InputAdornment,
    Pagination,
    Skeleton, Tooltip,
    TextField,
    Typography,
} from "@mui/material";
import DetectionImageList from "./components/DetectionImageList";
import DetectionImageModal
    from "./components/DetectionImageModal/DetectionImageModal";
import DownloadIcon from '@mui/icons-material/Download';
import DateRangeIcon from '@mui/icons-material/DateRange';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import LinkIcon from '@mui/icons-material/Link';
import CloseIcon from '@mui/icons-material/Close';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import ToolbarSelect from "./components/ToolbarSelect";
import AutocompleteCheckboxBrands
    from "./components/AutocompleteCheckboxBrands";
import SearchWithBtn from "./components/SearchWithBtn";
import Toast from "./components/Toast";
import Label from "./components/Label";
import SearchImage from "./components/SearchImage";
import HelpIcon from "@mui/icons-material/Help";
import ProgressiveImage from "./components/ProgressiveImage/ProgressiveImage";
function Detections({settings, location, user, history}) {
    const params = new URLSearchParams(location.search);

    const [brandList, setBrandList] = useState([]);
    const [brandIds, setBrandIds] = useState(
        params.get("brand")
            ? params.get("brand").split(",")
            : settings.brandIds || []
    );
    const [minScore, setMinScore] = useState(settings.minScore || 0.6);
    // Initializer could be done inline - but I need type inference (hack for TS)
    /** @type {import("./DataService").FeedDetectionResult[]} */
    const initializer = [];
    const [feedResults, setFeedResults] = useState(initializer);
    const [pageSize] = useState(50);
    const [mediaCount, setMediaCount] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [dataPresent, setDataPresent] = useState(true);
    const [currentPage, setCurrentPage] = useState(0);
    const [modalMedia, setModalMedia] = useState();
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [showQuickUploadModal, setShowQuickUploadModal] = useState(false);
    const [quickUploadUrl, setQuickUploadUrl] = useState("");
    const [quickUploadFile, setQuickUploadFile] = useState(null);
    const [quickUploadLoading, setQuickUploadLoading] = useState(false);
    const [quickUploadError, setQuickUploadError] = useState("");
    const [toast, setToast] = useState({
        open: false,
        message: '',
    })

    const handleCloseToast = () => {
        setToast({
            open: false,
            message: '',
        })
    }

    const showModalDetection = (media) => {
        history.push({
            pathname: "/media/detections",
            search: `?sessionId=${
                media.sessionId
            }&brand=${brandIds}&startDate=${dateBegin.format(
                "YYYY-MM-DD"
            )}&endDate=${dateEnd.format("YYYY-MM-DD")}`
        });
        setModalMedia(media)
        setShowModal(true);
    }

    const hideModal = () => {
        history.push({
            pathname: "/media/detections",
        });
        setShowModal(false);
    }
    /**
     * Modal Code end
     */
    const {
        startDate: dateBegin,
        endDate: dateEnd,
        selectedDateRange
    } = useDateRangePicker(params, settings);

    useEffect(() => {
        let isMounted = true;

        DataService.getActiveBrands().then(
            function (brandData) {
                if (!isMounted) return;

                const {brands} = brandData;
                const newBrandList = [];
                brands.forEach(brand => {
                    if (brand && brand.id) {
                        // special case, we're dealing with a single brand
                        newBrandList.push(brand);
                    } else {
                        Array.prototype.push.apply(newBrandList, brand);
                    }

                    // special case, we want to display only whitelisted brands
                    if (user.metadata && user.metadata.white_list) {
                        var whiteList = user.metadata.white_list.map(function (id) {
                            return "bra_" + id;
                        });

                        var filteredBrands = newBrandList.filter(function (brand) {
                            return whiteList.indexOf(brand.id) + 1;
                        });

                        // empty the list, need to be careful not to create new ref
                        newBrandList.length = 0;

                        Array.prototype.push.apply(newBrandList, filteredBrands);
                    }
                })

                const cleanedList = newBrandList.map(brand => {
                    return {
                        ...brand,
                        name: brand.name.trim(),
                        label: brand.name.trim()
                    }
                }).sort(
                    (a, b) => (a.name > b.name ? 1 : ((b.name > a.name) ? -1 : 0))
                )

                setBrandList(cleanedList);
            }
        ).catch(e => console.error(e));

        return () => {
            isMounted = false;
        };
    }, [
        user.detectionSetting.id,
        user.detectionSetting.meta.categories,
        user.metadata
    ]);

    // Activate
    useEffect(() => {
        let isMounted = true;

        setLoading(true);


        DataService.getFeed({
            dateBegin,
            dateEnd,
            brandIds: brandIds.map(x => String(x)),
            minScore,
            page: currentPage + 1,
            pageSize
        })
            .then(data => {
                if (!isMounted) return;

                const {
                    feed = [],
                    mediaCount,
                    total
                } = data || {};

                const count = Number(mediaCount ?? total ?? feed.length);
                setMediaCount(count);
                setPageCount(Math.ceil(count / pageSize));
                setDataPresent(count > 0);

                setFeedResults(feed);
            })
            .catch(e => {
                console.error(e)
            })
            .finally(() => {
                if (isMounted) {
                    setLoading(false)
                }
            });

        const sessionId = params.get("sessionId");

        if (sessionId) {
            DataService.detect(sessionId).then(({data}) => {
                if (!isMounted || !data) return;

                const feedData = data.data;
                if (feedData) {
                    showModalDetection(feedData)
                }
            });
        }

        return () => {
            isMounted = false;
        };

    }, [currentPage, brandIds, dateBegin, dateEnd, minScore, pageSize]);

    useEffect(() => {
        DataService.updateDeveloperMeta({
            minScore,
            brandIds
        });
    }, [minScore, brandIds]);


    function onBrandsSelect(brands) {
        setBrandIds(brands);
        setCurrentPage(0);
    }

    function onMinScoreChange(value) {
        setMinScore(value);
        setCurrentPage(0);
    }

    function onSessionSearchClick(sessionId) {
        DataService.detect(sessionId).then(({data}) => {
            if (data) {
                const feedData = data.data;
                if (feedData) {
                    showModalDetection(feedData)
                }
            }
        });
    }

    const getQuickUploadErrorMessage = (error) => {
        if (!error) {
            return "Failed to process quick upload";
        }
        const apiMessage = error?.response?.data?.errorMessage;
        if (apiMessage) {
            return apiMessage;
        }
        return error.message || "Failed to process quick upload";
    };

    const openQuickUploadModal = () => {
        setQuickUploadUrl("");
        setQuickUploadFile(null);
        setQuickUploadError("");
        setShowQuickUploadModal(true);
    };

    const closeQuickUploadModal = () => {
        if (quickUploadLoading) {
            return;
        }
        setQuickUploadError("");
        setShowQuickUploadModal(false);
    };

    const getDetectPayloadData = (payload) => {
        if (!payload) {
            return null;
        }
        if (payload.data) {
            return payload.data;
        }
        return payload;
    };

    const getDetectStatus = (httpStatus, payloadData) => {
        if (payloadData?.status != null) {
            return payloadData.status;
        }
        return httpStatus;
    };

    const getSessionIdFromPayload = (payload) => {
        if (!payload) {
            return null;
        }
        return (
            payload.sessionId
            || payload.sessionHash
            || payload.requestHash
            || payload.id
            || null
        );
    };

    const isDetectPending = (httpStatus, payloadData) => {
        return getDetectStatus(httpStatus, payloadData) === 202;
    };

    const isDetectReady = (payloadData) => {
        if (!payloadData || payloadData.status === 202) {
            return false;
        }
        return (
            payloadData.status === 200
            || Array.isArray(payloadData.detections)
            || Boolean(payloadData.mediaInfo)
        );
    };

    const buildQuickUploadFeed = (payloadData, sourceMediaUrl) => {
        if (!payloadData) {
            return null;
        }

        return {
            ...payloadData,
            mediaUrl: payloadData.mediaUrl || sourceMediaUrl,
            previewUrl: payloadData.previewUrl || sourceMediaUrl,
        };
    };

    const pollDetectResponse = async (sessionId, maxAttempts = 20, delayMs = 2500) => {
        for (let attempt = 0; attempt < maxAttempts; attempt++) {
            try {
                const response = await DataService.detect(sessionId);
                const data = getDetectPayloadData(response.data);
                if (isDetectReady(data)) {
                    return data;
                }
            } catch (error) {
                const statusCode = error?.response?.status;
                if (statusCode && statusCode !== 202 && statusCode !== 404) {
                    throw error;
                }
            }
            await new Promise((resolve) => setTimeout(resolve, delayMs));
        }
        throw new Error("Timed out waiting for detection response");
    };

    const onQuickUploadSubmit = async () => {
        const hasUrl = quickUploadUrl.trim().length > 0;
        const hasFile = !!quickUploadFile;

        if (!hasUrl && !hasFile) {
            setQuickUploadError("Please provide an image URL or upload an image file");
            return;
        }

        if (hasUrl && hasFile) {
            setQuickUploadError("Use either image URL or image file, not both");
            return;
        }

        try {
            setQuickUploadError("");
            setQuickUploadLoading(true);

            const response = await DataService.postDetect({
                mediaUrl: hasUrl ? quickUploadUrl.trim() : undefined,
                mediaFile: hasFile ? quickUploadFile : undefined,
            });

            const statusCode = response?.status;
            const payloadData = getDetectPayloadData(response?.data);

            if (isDetectReady(payloadData)) {
                const filePreviewUrl = hasFile ? URL.createObjectURL(quickUploadFile) : null;
                const sourceMediaUrl = hasUrl ? quickUploadUrl.trim() : filePreviewUrl;
                const feedData = buildQuickUploadFeed(payloadData, sourceMediaUrl);
                showModalDetection(feedData);
                setShowQuickUploadModal(false);
                return;
            }

            if (isDetectPending(statusCode, payloadData)) {
                const sessionId = getSessionIdFromPayload(payloadData);
                if (!sessionId) {
                    throw new Error("Missing session id for async detection");
                }
                const asyncData = await pollDetectResponse(sessionId);
                const filePreviewUrl = hasFile ? URL.createObjectURL(quickUploadFile) : null;
                const sourceMediaUrl = hasUrl ? quickUploadUrl.trim() : filePreviewUrl;
                const feedData = buildQuickUploadFeed(asyncData, sourceMediaUrl);
                showModalDetection(feedData);
                setShowQuickUploadModal(false);
                return;
            }

            throw new Error("Unexpected response while uploading media");
        } catch (error) {
            setQuickUploadError(getQuickUploadErrorMessage(error));
        } finally {
            setQuickUploadLoading(false);
        }
    };

    async function onCsvDownloadClick() {
        toastr.success(`Generated report for 0/${mediaCount} listings (0%)`, "", {
            timeOut: 0
        });

        const chunkSize = 75;
        /**
         * @type {import("./DataService").FeedDetectionResult[]}
         */
        let results = [];
        for (let index = 1; index <= Math.ceil(mediaCount / chunkSize); index++) {
            const chunkedResults = await DataService.getFeed({
                dateBegin,
                dateEnd,
                brandIds: brandIds.map((el) => String(el)),
                minScore,
                pageSize: chunkSize,
                page: index
            });
            const percentage = (
                (index / Math.ceil(mediaCount / chunkSize)) *
                100
            ).toFixed(0);
            $(".toast-message").text(
                `Generated report for ${Math.min(
                    index * chunkSize,
                    mediaCount
                )}/${mediaCount} listings (${percentage}%)`
            );

            results = results.concat(chunkedResults.feed);
        }

        toastr.remove();

        let csvContent = "";
        var header = [
            "Request Hash",
            "Media URL",
            "Confidence",
            "Brand",
            "Brand ID",
            "Coords",
            "Area"
        ];
        if (user.isDetectMultipleScraping) {
            header.push("Original URL")
        }

        const csvData = results.reduce((acc, record) => {
            record.detections.forEach(detection => {
                var line = [
                    record.sessionId,
                    record.mediaUrl,
                    detection.confidence,
                    detection.name,
                    detection.id,
                    detection.coordinates,
                    detection.area
                ]
                if (user.isDetectMultipleScraping) {
                    if (record.meta && record.meta.originalUrl) {
                        line.push(record.meta.originalUrl.trim())
                    } else {
                        line.push("")
                    }
                }
                acc.push(line.map(val => `"${val}"`).join(","))
            });
            return acc;
        }, []);

        csvContent += `${header.join(",")}\n`;
        csvContent += csvData.join("\n");

        const blob = new Blob([csvContent], {
            type: "text/csv"
        });
        const objectUrl = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.setAttribute("href", objectUrl);

        const fileName = `${dateBegin.format("YYYY-MM-DD")}-${dateEnd.format(
            "YYYY-MM-DD"
        )}`;

        link.setAttribute("download", `${fileName}.csv`);
        link.click();
    }

    const copyDetectionModalLinkToClip = () => {
        const currentUrl = window.location.href;

        navigator.clipboard
            .writeText(currentUrl)
            .then(() =>
                setToast({
                    open: true,
                    message: 'Modal Url successful copied to Clipboard'
                })
            )
            .catch(err => {
                setToast({
                    open: true,
                    message: 'Error: impossible send url to clipboard',
                })
            });


    }

    return (
        <>
            <DetectionImageModal
                open={showModal}
                copyToClip={copyDetectionModalLinkToClip}
                handleClose={hideModal}
                feed={modalMedia}
            />
            <Card
                raised={true}
                sx={{
                    p: 1,
                    mb: 5,
                }}
            >
                <Grid
                    container
                    spacing={2}
                    alignItems={'center'}
                    sx={{
                        p: 1,
                    }}
                >
                    <Grid item>
                        <Label>
                            Date range
                        </Label>
                    </Grid>
                    <Grid item>
                        <div className="form-control"
                             lg-range-selector=""
                             style={{
                                 borderColor: '#8092A6',
                                 color: '#02264D'
                             }}
                        >
                            {selectedDateRange}
                        </div>
                    </Grid>
                    <Grid item>
                        <Label>
                            Brands
                        </Label>
                    </Grid>
                    <Grid item>
                        <AutocompleteCheckboxBrands
                            brands={brandList}
                            value={brandIds}
                            onChange={(list) => {
                                onBrandsSelect(list)
                            }}
                        />
                    </Grid>
                    <Grid item>
                        <Label>
                            Confidence
                        </Label>
                    </Grid>
                    <Grid item>
                        <ToolbarSelect
                            initialState={minScore}
                            onChange={onMinScoreChange}
                            options={
                                [
                                    "ALL",
                                    "0.4",
                                    "0.6",
                                    "0.8",
                                    "1.0",
                                ]
                            }
                        />
                    </Grid>
                    <Grid
                        item
                        sx={{
                            marginLeft: 'auto'
                        }}
                    >
                        <SearchImage
                            placeholder={"View session ID"}
                            onChange={onSessionSearchClick}
                        />
                    </Grid>
                    <Grid item>
                        <Button
                            color={'success'}
                            variant={'contained'}
                            startIcon={<DownloadIcon/>}
                            onClick={openQuickUploadModal}
                        >
                            Quick Upload
                        </Button>
                    </Grid>
                    <Grid item>
                        <Button
                            color={'info'}
                            variant={'contained'}
                            startIcon={<DownloadIcon/>}
                            onClick={onCsvDownloadClick}
                        >
                            CSV
                        </Button>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs={12} sx={{
                        p: 1,
                        mb: 1,
                        backgroundColor: "#DEE3E8",
                        fontSize: '14px',
                        display: 'flex',
                    }}>
                        <div>
                            {
                                loading
                                    ? <Skeleton variant={'text'} width={100}/>
                                    : <span> {Number(mediaCount).toLocaleString()} <b>Media</b> </span>
                            }
                        </div>
                        <div className="ml-auto">
                            <Tooltip
                                title="Media with detections"
                                placement={'left'}
                            >
                                <HelpIcon sx={{color: '#8092A6'}}/>
                            </Tooltip>
                        </div>
                    </Grid>
                    <Grid item xs={12}>
                        <DetectionImageList
                            loading={loading}
                            onClick={showModalDetection}
                            feeds={feedResults.filter(item => !!item.detections.length)}
                        />
                        {
                            (Object.keys(feedResults.filter(item => !!item.detections.length)).length === 0 && !loading)
                            && <Grid container justifyContent={'center'}
                                     alignItems={'center'}>
                                <Grid item xs={8} sx={{my: 4}}>
                                    <Typography
                                        variant={'h3'}
                                    >
                                        Uh oh...
                                    </Typography>
                                    <Typography
                                        variant={'h6'}
                                    >
                                        Sorry! We couldn't find any data using the
                                        filters selected. Maybe
                                        try something else?
                                    </Typography>
                                </Grid>
                            </Grid>

                        }
                    </Grid>
                    {pageCount > 1 &&
                        <Grid container justifyContent={'center'}
                              alignItems={'center'}>
                            <Pagination
                                variant="outlined"
                                page={currentPage + 1}
                                onChange={(e, page) => {
                                    setCurrentPage(page - 1);
                                }}
                                count={pageCount}
                            />
                        </Grid>
                    }
                </Grid>

            </Card>
            <Toast
                open={toast.open}
                handleClose={handleCloseToast}
                message={toast.message}
            />
            <Dialog
                open={showQuickUploadModal}
                onClose={closeQuickUploadModal}
                fullWidth={true}
                maxWidth={"sm"}
                disableEscapeKeyDown={quickUploadLoading}
                PaperProps={{sx: {borderRadius: 2}}}
            >
                <DialogTitle sx={{pb: 1}}>
                    <Box sx={{display: "flex", alignItems: "center", gap: 1}}>
                        <CloudUploadOutlinedIcon color="primary"/>
                        <Typography variant="h6" component="span">
                            Quick Upload
                        </Typography>
                    </Box>
                    <Typography variant="body2" color="text.secondary" sx={{mt: 0.5}}>
                        Run logo detection on a single image from a URL or your device.
                    </Typography>
                </DialogTitle>
                <DialogContent dividers sx={{pt: 2}}>
                    {quickUploadError && (
                        <Alert
                            severity="error"
                            sx={{mb: 2}}
                            onClose={() => setQuickUploadError("")}
                        >
                            {quickUploadError}
                        </Alert>
                    )}
                    <TextField
                        fullWidth
                        label="Image URL"
                        placeholder="https://example.com/image.jpg"
                        value={quickUploadUrl}
                        onChange={(event) => {
                            setQuickUploadUrl(event.target.value);
                            setQuickUploadError("");
                        }}
                        disabled={quickUploadLoading || !!quickUploadFile}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <LinkIcon fontSize="small" color="action"/>
                                </InputAdornment>
                            ),
                        }}
                    />
                    <Divider sx={{my: 2.5}}>
                        <Typography variant="caption" color="text.secondary" sx={{px: 1}}>
                            OR
                        </Typography>
                    </Divider>
                    <Box
                        sx={{
                            border: "1px dashed",
                            borderColor: quickUploadFile ? "primary.main" : "divider",
                            borderRadius: 1,
                            bgcolor: quickUploadFile ? "action.hover" : "background.default",
                            p: 2,
                            textAlign: "center",
                        }}
                    >
                        {quickUploadFile ? (
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    gap: 1,
                                    textAlign: "left",
                                }}
                            >
                                <Box sx={{display: "flex", alignItems: "center", gap: 1, minWidth: 0}}>
                                    <ImageOutlinedIcon color="primary"/>
                                    <Box sx={{minWidth: 0}}>
                                        <Typography variant="body2" noWrap>
                                            {quickUploadFile.name}
                                        </Typography>
                                        <Typography variant="caption" color="text.secondary">
                                            {(quickUploadFile.size / 1024).toFixed(1)} KB
                                        </Typography>
                                    </Box>
                                </Box>
                                <IconButton
                                    size="small"
                                    aria-label="Remove selected image"
                                    onClick={() => {
                                        setQuickUploadFile(null);
                                        setQuickUploadError("");
                                    }}
                                    disabled={quickUploadLoading}
                                >
                                    <CloseIcon fontSize="small"/>
                                </IconButton>
                            </Box>
                        ) : (
                            <>
                                <Typography variant="body2" color="text.secondary" sx={{mb: 1.5}}>
                                    Upload a JPG, PNG, or other image format
                                </Typography>
                                <label htmlFor="quick-upload-file-input">
                                    <input
                                        id="quick-upload-file-input"
                                        type="file"
                                        accept="image/*"
                                        style={{display: "none"}}
                                        onChange={(event) => {
                                            const file = event.target.files?.[0] || null;
                                            setQuickUploadFile(file);
                                            setQuickUploadError("");
                                            if (file) {
                                                setQuickUploadUrl("");
                                            }
                                            event.target.value = "";
                                        }}
                                        disabled={quickUploadLoading || quickUploadUrl.trim().length > 0}
                                    />
                                    <Button
                                        variant="outlined"
                                        component="span"
                                        startIcon={<CloudUploadOutlinedIcon/>}
                                        disabled={quickUploadLoading || quickUploadUrl.trim().length > 0}
                                    >
                                        Choose image
                                    </Button>
                                </label>
                            </>
                        )}
                    </Box>
                </DialogContent>
                <DialogActions
                    sx={{
                        borderTop: "1px solid",
                        borderColor: "divider",
                        px: 3,
                        py: 2,
                    }}
                >
                    <Button onClick={closeQuickUploadModal} disabled={quickUploadLoading}>
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        onClick={onQuickUploadSubmit}
                        disabled={quickUploadLoading || (!quickUploadUrl.trim() && !quickUploadFile)}
                        startIcon={
                            quickUploadLoading
                                ? <CircularProgress size={18} color="inherit"/>
                                : null
                        }
                    >
                        {quickUploadLoading ? "Processing..." : "Detect"}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default Detections;
